import React, { memo } from 'react'
import styled from 'styled-components'
import { TextSmall } from '../TextPrimitives'
import { transparentUI } from '../../style-functions'

const Wrapper = styled(TextSmall)`
  position: relative;
  max-width: 25rem;
  padding: 1rem 2rem;
  transform: translateY(-50%);
  border-radius: 0.5rem;
  color: ${({ theme }) => theme.colors.text.inverse};
  ${transparentUI}
`

const Label = ({ children = 'label', size = 0, onClick = x => x }) => (
  <Wrapper size={size} onClick={onClick}>
    {children}
  </Wrapper>
)

export default memo(Label)
